import type { RouteConfig } from 'vue-router';
import ResetRequest from '../reset-request/components/ResetRequest.vue';
import ResetPassword from '../reset-password/components/ResetPassword.vue';
import SelectEntity from '../select-entity/components/SelectEntity.vue';
import Login from '../login/components/Login.vue';
import PasswordExpired from '../password-expired/components/PasswordExpired.vue';

export const routes: RouteConfig[] = [
  {
    path: '/reset/',
    name: 'request',
    meta: {
      title: 'Reset password',
    },
    component: ResetRequest,
  },
  {
    path: '/reset/:userId/:passwordKey',
    name: 'reset-password',
    meta: {
      title: 'Reset password',
    },
    component: ResetPassword,
  },
  {
    path: '/password-expired',
    name: 'password-expired',
    meta: {
      title: 'Password expired',
    },
    component: PasswordExpired,
  },
  {
    path: '/select-entity',
    name: 'select-entity',
    meta: {
      title: 'Select entity',
    },
    component: SelectEntity,
  },
  {
    path: '*',
    name: 'login',
    meta: {
      title: 'Login',
    },
    component: Login,
  },
];
